module.exports = __webpack_public_path__ + "img/drawer.ae48cd8.svg";